import { Link } from 'react-router-dom';
import { useState } from 'react';
import '../Styles/footer.css';

function Footer() {
  const [email, setEmail] = useState('');
  const [subscribing, setSubscribing] = useState(false);
  const [subscribeMessage, setSubscribeMessage] = useState({ type: '', text: '' });

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setSubscribing(true);
    setSubscribeMessage({ type: '', text: '' });

    try {
      const res = await fetch('/api/subscribers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data.error || 'Something went wrong. Please try again.');
      }

      setSubscribeMessage({ type: 'success', text: 'Thanks for subscribing!' });
      setEmail('');
    } catch (err) {
      setSubscribeMessage({
        type: 'error',
        text: err.message || 'Something went wrong. Please try again.',
      });
    } finally {
      setSubscribing(false);
    }
  // clear the message after 1 second
    setTimeout(() => {
      setSubscribeMessage({ type: '', text: '' });
    }, 3000);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo + Contact */}
        <div className="footer-col footer-brand">
          <div className="footer-logo">
            <img src="/assets/vnkm_footer_logo.png" alt="Vanakkam HRD" className="footer-logo-img" />
          </div>
            {/* NEW DESCRIPTION */}
  <p className="footer-description">
  Founded in 2022, Vanakkam HRD is a leading HR community in India. Connecting HR professionals, industry leaders, and academia.
</p>
          <p className="footer-contact">
  <span className="icon">
    <img
      src="/assets/footer_phone.png"
      alt="Phone"
      className="footer-icon"
    />
  </span>

  <a href="tel:+918248238229">+91 8248238229</a>
</p>

<p className="footer-contact">
  <span className="icon">
    <img
      src="/assets/footer_mail.png"
      alt="Mail"
      className="footer-icon"
    />
  </span>

  <a href="mailto:support@vanakkamhrd.com">
    support@vanakkamhrd.com
  </a>
</p>
        </div>

        {/* Useful Links */}
        <div className="footer-col footer-useful-links">
  <h4>Useful Links</h4>
          <ul>
            <li>
  <Link to="/home">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    Home
  </Link>
</li>

<li>
  <Link to="/whatWeDo">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    About Us
  </Link>
</li>

<li>
  <Link to="/getcertified">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    Get Certified
  </Link>
</li>

<li>
  <Link to="/events">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    Events
  </Link>
</li>

<li>
  <Link to="/jointhecommunity">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    Join the Community
  </Link>
</li>
          </ul>
        </div>

        {/* Our Platforms */}
        <div className="footer-col">
          <h4>Our Platforms</h4>
          <ul>
            <li>
  <Link to="/hrcommunity">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    HR Community Network
  </Link>
</li>
           <li>
  <Link to="/industryacademia">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    Industry-Academia Connect
  </Link>
</li>
            <li>
  <Link to="/employeebranding">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    Employer Branding & Recognition
  </Link>
</li>
          </ul>
        </div>

        {/* Newsletter */}
        <div className="footer-col footer-newsletter">
          <h4>Subscribe to our Newsletter</h4>
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={subscribing}>
              {subscribing ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
          {subscribeMessage.text && (
            <p
              className={
                subscribeMessage.type === 'success'
                  ? 'newsletter-success-msg'
                  : 'newsletter-error-msg'
              }
            >
              {subscribeMessage.text}
            </p>
          )}
          <ul className="footer-legal">
                       <li>
  <Link to="/terms">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    Terms & Conditions
  </Link>
</li>
                       <li>
  <Link to="/privacy">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    Privacy Policy
  </Link>
</li>
                       <li>
  <Link to="/refund">
    <img src="/assets/footer_arrow.png" alt="Arrow" className="footer-arrow" />
    Refund Policy
  </Link>
</li>
          </ul>
        </div>
      </div>

      {/* Left line - social icons - right line */}
      <div className="footer-social-row">
        <span className="footer-line"></span>

        <div className="footer-social">
          <a href="https://www.linkedin.com/company/vanakkam-hrd/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <img src="/assets/footer_linkedin.png" alt="LinkedIn" className="social-icon" />
          </a>
          <a href="https://www.facebook.com/share/1GQXV1GaYS/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <img src="/assets/footer_facebook.png" alt="Facebook" className="social-icon" />
          </a>
          <a href="https://www.instagram.com/vanakkam_hrd/?hl=en-gb" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <img src="/assets/footer_insta.png" alt="Instagram" className="social-icon" />
          </a>
          <a href="https://www.youtube.com/@VanakkamHRD" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <img src="/assets/footer_youtube.png" alt="YouTube" className="social-icon" />
          </a>
        </div>

        <span className="footer-line"></span>
      </div>

      <p className="footer-copyright">© Vanakkam HRD 2026. All rights reserved.</p>
    </footer>
  );
}

export default Footer;